import React, { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import UtilsApi from "../../Services/Utils/Utils";

const WYSIWIGEditor = (props) => {
  const utilsService = new UtilsApi();
  const editorRef = useRef(null);

  // TinyMCE v6 dropped the (blobInfo, success, failure) callback signature in
  // favor of (blobInfo, progress) => Promise<string>. Returning the URL
  // directly; throw to signal failure.
  const handleUpload = async (blobInfo) => {
    const form = new FormData();
    form.append("image", blobInfo.blob(), blobInfo.filename());
    const response = await utilsService.uploadImage(form);
    if (!response || response.status !== 200) {
      throw new Error(response?.data?.message || "Image upload failed");
    }
    return response.data.data[0].url;
  };


  return (
    <Editor
      apiKey={process.env.REACT_APP_TINTINYMCE_KEY}
      onInit={(evt, editor) => (editorRef.current = editor)}
      initialValue={props.data}
      onBlur={(e) => {
        props.onChange(e.target.getContent());
      }}
      init={{
        height: props.height ? props.height : 400,
        menubar: false,
        plugins: [
          "advlist",
          "autolink",
          "lists",
          "link",
          "image",
          "charmap",
          "preview",
          "anchor",
          "searchreplace",
          "visualblocks",
          "code",
          "fullscreen",
          "insertdatetime",
          "media",
          "table",
          "help",
          "wordcount",
        ],
        toolbar:
          "undo redo | formatselect | " +
          "bold italic underline forecolor backcolor | " +
          "alignleft aligncenter alignright alignjustify | " +
          "bullist numlist outdent indent | " +
          "image media table link | " +
          "removeformat | code preview | help",

        images_upload_handler: handleUpload,

        content_style:
          "body { font-family:Kern,sans-serif; font-size:14px; } img{display:inline-block;max-width:100%;height:auto;}",

        image_caption: true,
      }}
      disabled={props.isDisableFields}
    />
  );
};

export default WYSIWIGEditor;
